import { render } from "./publicDoc.vue?vue&type=template&id=9a6e7fdc"
import script from "./publicDoc.vue?vue&type=script&lang=js"
export * from "./publicDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__